import { useDYAppConfig } from "~/modules/nuxt3-module-doyac/composables/config"
import { $dy__fetchWithToken } from "~/modules/nuxt3-module-doyac/composables/fetch"

interface DYAPersonalSetting_Raw {
  no?: number
  userNo: number
  settings: DYAPersonalSetting
}

export interface DYAPersonalSetting {
  favoriteMenu: DYFavoriteMenu[]
  fontSize: number
  miniSideBar: boolean
}

export interface DYFavoriteMenu {
  title: string
  to?: string
  href?: string
  target?: '_blank'|'_self'
}

export const DEFAULT_SETTINGS: DYAPersonalSetting = {
  favoriteMenu: [],
  fontSize: 16,
  miniSideBar: false
}

export function useDYAPersonalSetting() {
  const { API_BASE_URL } = useDYAppConfig()

  const get = async () => {
    const raw = await $dy__fetchWithToken<DYAPersonalSetting_Raw>(`${API_BASE_URL}/api/admin-personal-settings/me`)
    return (raw.settings ?? DEFAULT_SETTINGS) as DYAPersonalSetting
  }

  const save = async (settings: DYAPersonalSetting) => {
    const raw = await $dy__fetchWithToken<DYAPersonalSetting_Raw>(
      `${API_BASE_URL}/api/admin-personal-settings/me`,
      { method: 'post', body: { settings } }
    )
    
    return (raw.settings ?? DEFAULT_SETTINGS) as DYAPersonalSetting
  }

  return {
    get,
    save
  }
}